import SocialLinks from "../../common/SocialLinks/SocialLinks.jsx";
import styles from "./ProductModal.module.css";

function ProductModal({
  isOpen,
  onClose,
  product,
}) {
  if (!isOpen || !product) {
    return null;
  }

  return (
    <div
      className={styles.overlay}
      onClick={onClose}
    >
      <div
        className={styles.modal}
        onClick={(event) => event.stopPropagation()}
      >
        <button
          className={styles.closeButton}
          onClick={onClose}
          aria-label="Fechar modal"
        >
          ×
        </button>

        {product.image && (
          <img
            className={styles.image}
            src={product.image}
            alt={product.name}
          />
        )}

        <div className={styles.content}>
          {product.name && (
            <h2 className={styles.name}>
              {product.name}
            </h2>
          )}

          {product.description && (
            <p className={styles.description}>
              {product.description}
            </p>
          )}

          {product.price && (
            <p className={styles.price}>
              {product.price}
            </p>
          )}

            <div className={styles.social}>
              <SocialLinks />
            </div>  
        </div>
      </div>
    </div>
  );
}

export default ProductModal;